import React from 'react';
import {Button, CSSModule, FormGroup, InputGroup, InputGroupAddon} from "reactstrap";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faList, faPlus} from "@fortawesome/free-solid-svg-icons";

interface IProps {
  selected?: string;
  onNew?: (e: any) => void;
  onList?: (e: any) => void;
  disabled?: boolean;
  size?: string;
  addonsCss?: CSSModule
  className?:string;
}

const InputCreateSelectComponent = ({ selected = "", onNew, onList, disabled, size = "sm", addonsCss, className }: IProps) => {
  return (
    <FormGroup>
      <InputGroup style={addonsCss}>
        <input
          type="text"
          className={className || `form-control form-control-${size}`}
          disabled
          value={selected}
          onChange={()=>{}}
        />
        <InputGroupAddon addonType="append">
          <Button color="primary" size={size} onClick={onNew} disabled={disabled}>
            <FontAwesomeIcon icon={faPlus}/>
          </Button>
        </InputGroupAddon>
        <InputGroupAddon addonType="append">
          <Button color="success" size={size} onClick={onList} disabled={disabled}>
            <FontAwesomeIcon icon={faList}/>
          </Button>
        </InputGroupAddon>
      </InputGroup>
    </FormGroup>
  );
};
export default InputCreateSelectComponent;
